// extracted by mini-css-extract-plugin
module.exports = {"about":"about-module--about--2h0bK","about__container":"about-module--about__container--1YsM8","textbox__heading":"about-module--textbox__heading--3v3RX"};